import { Typography, Box } from "@mui/material";
import { EditableInputDisplay } from "../../EditableComponents";
import { useEffect, useState } from "react";
import { LoadingPaper } from "../../LoadingComponents";

export default function RecapitiPatient({
  _patient,
  editMode,
  setParentValue,
}) {
  const [patient, setPatient] = useState(_patient);

  useEffect(() => {
    setPatient(_patient);
  }, [_patient]);

  return (
    <Box
      sx={{
        display: "grid",
        margin: "auto",
        gridTemplateColumns: "1fr 1fr",
        width: "100%",
      }}
    >
      {patient !== undefined ? (
        <>
          <Box sx={{ margin: "10px" }}>
            <Typography fontWeight={"bold"} fontStyle={"italic"}>
              Indirizzo primario
            </Typography>
            <EditableInputDisplay
              id={"address"}
              label={"Indirizzo:"}
              initialValue={patient.address}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"city"}
              label={"Città:"}
              initialValue={patient.city}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"province"}
              label={"Provincia:"}
              initialValue={patient.province}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"cap"}
              label={"CAP:"}
              initialValue={patient.cap}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
          </Box>
          <Box sx={{ margin: "10px" }}>
            <Typography fontWeight={"bold"} fontStyle={"italic"}>
              Indirizzo secondario
            </Typography>
            {patient.address_secondary || editMode ? (
              <>
                <EditableInputDisplay
                  id={"address_secondary"}
                  label={"Indirizzo:"}
                  initialValue={patient.address_secondary}
                  setEditMode={editMode}
                  inputMode={"text"}
                  setParentValue={setParentValue}
                />
                <EditableInputDisplay
                  id={"city_secondary"}
                  label={"Città:"}
                  initialValue={patient.city_secondary}
                  setEditMode={editMode}
                  inputMode={"text"}
                  setParentValue={setParentValue}
                />
                <EditableInputDisplay
                  id={"province_secondary"}
                  label={"Provincia:"}
                  initialValue={patient.province_secondary}
                  setEditMode={editMode}
                  inputMode={"text"}
                  setParentValue={setParentValue}
                />
                <EditableInputDisplay
                  id={"cap_secondary"}
                  label={"CAP:"}
                  initialValue={patient.cap_secondary}
                  setEditMode={editMode}
                  inputMode={"text"}
                  setParentValue={setParentValue}
                />
              </>
            ) : (
              <Typography>Nessun indirizzo secondario specificato</Typography>
            )}
          </Box>
          <Box sx={{ margin: "10px" }}>
            <Typography fontWeight={"bold"} fontStyle={"italic"}>
              Informazioni aggiuntive
            </Typography>
            <EditableInputDisplay
              id={"weight"}
              label={"Peso:"}
              initialValue={patient.weight}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
              adornment={"kg"}
            />
            <EditableInputDisplay
              id={"height"}
              label={"Altezza:"}
              initialValue={patient.height}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
              adornment={"cm"}
            />
            <EditableInputDisplay
              id={"hypertensive"}
              label={"Iperteso:"}
              initialValue={patient.hypertensive}
              setEditMode={editMode}
              inputMode={"bool"}
              setParentValue={setParentValue}
            />
          </Box>
          <Box sx={{ margin: "10px" }}>
            <Typography fontWeight={"bold"} fontStyle={"italic"}>
              Contatti
            </Typography>
            <EditableInputDisplay
              id={"phone"}
              label={"Telefono:"}
              initialValue={patient.phone}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"mobile"}
              label={"Cellulare:"}
              initialValue={patient.mobile}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
            <EditableInputDisplay
              id={"email"}
              label={"Email:"}
              initialValue={patient.email}
              setEditMode={editMode}
              inputMode={"text"}
              setParentValue={setParentValue}
            />
          </Box>
        </>
      ) : (
        <LoadingPaper />
      )}
    </Box>
  );
}
